"use client";

import { useTranslations } from "next-intl";
import Icon from "../../../common/components/Icon";

export enum CuttingType {
  ROUND = "round",
  ELLIPSE = "ellipse",
  TEMPLATE = "template",
}

const FormattedCuttingDetails = ({ title, lines }) => (
  <div>
    <span className="mb-2 fs-7">{title}</span>
    <ul className="list-disc mb-0 fs-7">
      {lines?.map((line) => <li key={line}>{line}</li>)}
    </ul>
  </div>
);

export const formatCutting = (t, cutting, full = false) => {
  if (!cutting) return full ? t("cutting_disabled_help") : t("uncut");
  const { type, value } = cutting || {};

  switch (type) {
    case CuttingType.ROUND:
      return full ? (
        <FormattedCuttingDetails
          title={t("cutting_last_selected", { cutting: "" })}
          lines={[
            t("cutting_template_round"),
            t("diameter_in_mm", { width: value }),
          ]}
        />
      ) : (
        t("diameter_in_mm", { width: value })
      );

    case CuttingType.ELLIPSE:
      const { width, height } = value || {};
      return full ? (
        <FormattedCuttingDetails
          title={t("cutting_last_selected", { cutting: "" })}
          lines={[
            t("cutting_template_elliptical"),
            t("width_in_mm", { width }),
            t("height_in_mm", { height }),
          ]}
        />
      ) : (
        `${t("width_in_mm", { width })}; ${t("height_in_mm", { height })}`
      );

    case CuttingType.TEMPLATE:
      return t("cutting_template_cart_info");

    default:
      return "";
  }
};

export type Cutting =
  | {
      type: CuttingType.ELLIPSE;
      value: {
        height: number;
        width: number;
      };
    }
  | {
      type: CuttingType.ROUND;
      value: number;
    }
  | {
      type: CuttingType.TEMPLATE;
      value: undefined | null;
    };

const CuttingInfo = ({ cutting }: { cutting: Cutting }) => {
  const t = useTranslations();
  return (
    <span className="cutting-info d-inline-flex gap-2 align-items-center border-radius">
      <Icon icon="cut" className="icon--sm" />
      <span className="fs-data">{formatCutting(t, cutting)}</span>
    </span>
  );
};

export default CuttingInfo;
